module.exports = __webpack_public_path__ + "media/images/groupphasebet__sample@2x-c7db246cd774790a3113186970f770a8.png";